export const TOKEN = 'KYC_BILLING_TOKEN'
export const API_SERVER_URL = 'KYC_API_SERVER_URL'
export const LANGUAGE_CODE = 'KYC_LANGUAGE_CODE'
